<template>
    <div>
        <div>
            <h5 class="text-center">Votre Signature</h5>
        </div>

        <VueSignaturePad
        id="signature"
        width="100%"
        height="200px"
        ref="signaturePad"
        >
        </VueSignaturePad>
        <div style="width:100%" class="d-flex justify-content-between mt-2">
            <button type="button" class="btn btn-danger" @click="clear">Supprimer</button>
            <button type="button" class="btn btn-warning" @click="undo">Annuler</button>
            <button type="button" class="btn btn-info" @click="save">Sauvegarder</button>
        </div>

        <input type="hidden" name="signature" v-model="image">
    </div>
</template>

<script>
import VueSignaturePad from 'vue-signature-pad';
export default {
    props: {
        signature: String,
    },
    data(){
        return {
            dataImage: null,
            image: null,
        }
    },
    components: {
        VueSignaturePad,
    },
    methods: {
        clear() {
            this.$refs.signaturePad.clearSignature();
            this.dataImage = null;
        },
        undo() {
            this.$refs.signaturePad.undoSignature();
        },
        save() {
            var {isEmpty, data} = this.$refs.signaturePad.saveSignature();
            if(isEmpty) {
                this.dataImage = null;
            }else {
                this.dataImage = data;
                this.image = data.split('base64,')[1];
            }
        },
        load() {
            this.$refs.signaturePad.fromDataURL(this.dataImage);
        },
        toDataUrl(blob, callback) {
            var reader = new FileReader();
            reader.onloadend = function() {
                callback(reader.result);
            }
            reader.readAsDataURL(blob);
        }
    },
    mounted() {
        if(this.signature != "") {
            var $this = this;
            setTimeout(function() {
                axios.get($this.signature, {
                    responseType: 'blob'
                })
                .then(res => {
                    var blob = res.data;
                    $this.toDataUrl(blob, function(result) {
                        $this.dataImage = result;
                        $this.$refs.signaturePad.fromDataURL(result);
                    });
                });
                }, 100);
        }
    }
}
</script>

<style scoped>
    #signature {
        border: 2px solid #0B96AE;
        border-radius: 4px;
    }
</style>
